import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import hasUpdateProgram from '../../../hoc/hasUpdateProgram'
import toJS from '../../../hoc/toJS'
import config from '../../../config.json'
import { CLI, CLI_CINEMA_CLIENT_ID, PROGRAM_ADVERTISEMENTS_ITEMS, PROGRAM_ADVERTISEMENTS_ORDER, PROGRAM_CINEMAS, PROGRAM_WEISCHERAD_ITEMS } from '../../../constants/state'
import getData from '../../../functions/getData'
import { advertisementsDeleteItem } from '../../../actions'
import { ADVERTISEMENT } from '../../../constants/itemTypes'
import PageAdvertisementPage from '../present/PageAdvertisementPage'
import getCinemaType from '../../../functions/getCinemaType'

const mapDispatchToProps = (dispatch, ownProps) => ({
    addItem: (type) => {
        ownProps.history.push(`${config.routes.advertisement.path}/${ADVERTISEMENT}/${type}/addItem/form`)
    },
    editItem: (pk) => {
        ownProps.history.push(`${config.routes.advertisement.path}/${ADVERTISEMENT}/${pk}`)
    },
    deleteItem: (pk) => {
        dispatch(advertisementsDeleteItem(pk))
    }
})

const mapStateToProps = state => ({
    items: getData(state, PROGRAM_ADVERTISEMENTS_ITEMS),
    order: getData(state, PROGRAM_ADVERTISEMENTS_ORDER),
    weischerItems: getData(state, PROGRAM_WEISCHERAD_ITEMS),
    cliData: getData(state, CLI),
    cliCinemas: getData(state, PROGRAM_CINEMAS),
    clientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID),
    adsConfig: state.getIn(['wpServerData', 'data', 'data', 'advertisement_config'])
})

const PageAdvertisement = ({cliData, programStatus, adsConfig, programError, items, order, weischerItems, addItem, editItem, deleteItem, onUpdateProgram, cliCinemas, clientCinemaId, goBackPath}) => {
   return <PageAdvertisementPage
        addItem={addItem} 
        editItem={editItem}
        deleteItem={deleteItem}
        adsConfig={adsConfig}
        items={items} 
        order={order}
        weischerItems={weischerItems}
        programStatus={programStatus}
        programError={programError}
        onUpdateProgram={onUpdateProgram}
        cinemaType={getCinemaType(cliCinemas)}
        cliCinemas={cliCinemas}
        clientCinemaId={clientCinemaId}
        cliData={cliData}
        closePagePath={goBackPath}
    />
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    hasUpdateProgram(),
    toJS()
)(PageAdvertisement)